import { useEffect } from "react";
import { PrivacyContent } from "@/components/privacy/PrivacyContent";

export default function Privacy() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Privacy Policy | Vitura";
    const style = document.createElement("link");
    style.rel = "stylesheet";
    style.href = "/privacy/policy.css";
    document.head.appendChild(style);
    const previous = [];
    for (const [name, content] of [["description", "Vitura’s privacy policy for sample requests, feedback, early access, website analytics, and communication preferences."], ["robots", "index, follow"]]) {
      const existing = document.querySelector(`meta[name="${name}"]`);
      const node = existing || document.createElement("meta");
      previous.push({ node, existing, content: node.getAttribute("content") });
      node.setAttribute("name", name);
      node.setAttribute("content", content);
      if (!existing) document.head.appendChild(node);
    }
    return () => {
      document.title = previousTitle;
      style.remove();
      previous.forEach(({ node, existing, content }) => {
        if (!existing) node.remove();
        else if (content === null) node.removeAttribute("content");
        else node.setAttribute("content", content);
      });
    };
  }, []);
  return <PrivacyContent />;
}